// extracted by mini-css-extract-plugin
module.exports = {"apply_name":"FJFilterApply_apply_name__3VAOo"};